module.exports = __webpack_public_path__ + "img/passport-back-illustration.a3fb5bfe.png";